import feathers from '@feathersjs/feathers';
const app = feathers();

//Auth
import auth from '@feathersjs/authentication-client';
app.configure(auth());

//import axios from 'axios';
import rest from '@feathersjs/rest-client';
const restClient = rest() //configure with connection URL base
app.configure(restClient.fetch(window.fetch));

import { writable } from 'svelte/store';
app.perms = writable(false);//store currently logged in user
app.email = writable(false);
app.userID = writable(false);
app.checkedToken = writable(false);

function AccountInfoSave(result){
	if(!result || !result.user) throw new Error('no user information found');
	//id: 1
	//email: "avi@bestfone.com"
	//permissions: "admin"
	app.perms.set(result.user.permissions);
	app.email.set(result.user.email);
	app.userID.set(result.user.id);
	}
function AccountInfoReset(){
	app.perms.set(false);
	app.email.set(false);
	app.userID.set(false);
	}

app.checkingToken = app.reAuthenticate()//safe to always try using a stored token on load.
	.then(AccountInfoSave)
	.catch(AccountInfoReset)
	.finally(function(){
		app.checkedToken.set(true);
	});

app.login = async function (email,password){
	//console.log(email, password);
	// Authenticate with the local email/password strategy 
	return app.authenticate({
		strategy: 'local',
		email: email,
		password: password
		})
	.then(AccountInfoSave)
	.catch(e => {
		// Show login page (potentially with `e.message`).
		AccountInfoReset();
		console.error('Authentication error', e);
		throw e; //e.message
		});
	}
app.logoutFull = function(){
	app.logout().then(AccountInfoReset);
	}


export default app;